import "./TableV2.css";
import edidIcon from "../../icons/edit.svg"


import Snackbar from "../SnackBar/SnackBar";
const TableVisitors = ({ title, visitors = [] }) => {
    return (
        <>


            <div className="vendors">
                {visitors.map((visitor, index) => (
                    <div key={index} className="vendor">
                        <span className="title">{visitor.first_name} {visitor.last_name}</span>
                        <span className="muted">{visitor.email}•{visitor.phone}</span>
                        <button className="btn btn-edit" ><img src={edidIcon} alt="edit icon" />
                        </button>
                    </div>
                ))}
            </div>














        </>
    );
};

export default TableVisitors;
